// Quack Pong — rally against the house duck, don't miss.
export function createPong(host) {
  const { ctx, input } = host; const W = host.W, H = host.H;
  const pw = 10, ph = 64; let ly = H / 2 - ph / 2, ry = H / 2 - ph / 2, ball;
  const reset = (dir) => { ball = { x: W / 2, y: H / 2, vx: 210 * dir, vy: Math.random() * 160 - 80 }; };
  reset(1);
  return {
    dim: "2d", w: W, h: H, controls: ["up", "down"], score: 0, over: false,
    frame(dt) {
      if (input.held.up) ly -= 360 * dt; if (input.held.down) ly += 360 * dt; ly = Math.max(0, Math.min(H - ph, ly));
      const target = ball.y - ph / 2; ry += Math.max(-250 * dt, Math.min(250 * dt, target - ry)); ry = Math.max(0, Math.min(H - ph, ry));
      ball.x += ball.vx * dt; ball.y += ball.vy * dt;
      if (ball.y < 6) { ball.y = 6; ball.vy *= -1; } if (ball.y > H - 6) { ball.y = H - 6; ball.vy *= -1; }
      if (ball.x < 20 + pw && ball.y > ly && ball.y < ly + ph && ball.vx < 0) { ball.vx = Math.abs(ball.vx) + 18; ball.vy += (ball.y - (ly + ph / 2)) * 3; this.score += 1; host.sfx.click?.(); }
      if (ball.x > W - 20 - pw && ball.y > ry && ball.y < ry + ph && ball.vx > 0) { ball.vx = -(Math.abs(ball.vx) + 12); ball.vy += (ball.y - (ry + ph / 2)) * 3; }
      if (ball.x < 0) { this.over = true; host.sfx.hit?.(); }
      if (ball.x > W) { this.score += 5; host.sfx.coin?.(); reset(-1); }
      ctx.fillStyle = "#05060f"; ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = "rgba(255,255,255,0.2)"; ctx.setLineDash([8, 10]); ctx.beginPath(); ctx.moveTo(W / 2, 0); ctx.lineTo(W / 2, H); ctx.stroke(); ctx.setLineDash([]);
      ctx.fillStyle = "#22d3ee"; ctx.fillRect(14, ly, pw, ph);
      ctx.fillStyle = "#f472b6"; ctx.fillRect(W - 14 - pw, ry, pw, ph);
      ctx.fillStyle = "#fde68a"; ctx.beginPath(); ctx.arc(ball.x, ball.y, 7, 0, 7); ctx.fill();
    },
  };
}
